import apiClient from './apiClient';

export const internalHandoverApi = {
    getHandovers: async () => {
        const response = await apiClient.get('/api/internal-handover');
        return response.data;
    },
    getHandoverDetails: async (id) => {
        const response = await apiClient.get(`/api/internal-handover/${id}`);
        return response.data;
    },
    createHandover: async (data) => {
        const response = await apiClient.post('/api/internal-handover', data);
        return response.data;
    },
    updateHandover: async (id, data) => {
        const response = await apiClient.put(`/api/internal-handover/${id}`, data);
        return response.data;
    },
    deleteHandover: async (id) => {
        const response = await apiClient.delete(`/api/internal-handover/${id}`);
        return response.data;
    }
};
